import { firstValueFrom } from 'rxjs';
import { DadosFornecedor, defaultDadosFornecedor, defaultFornecedorPedidoCompra, FornecedorPedidoCompraItens } from './../../interface/fornecedor-pedido-compra';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PoDialogService, PoTableColumn } from '@po-ui/ng-components';
import { FornecedorPedidoCompra } from 'src/app/interface/fornecedor-pedido-compra';
import { AuthService } from 'src/app/service/auth.service';
import { PedidoCompraService } from '../pedido-compra/service/pedido-compra.service';
import { PoStorageService } from '@po-ui/ng-storage';

@Component({
  selector: 'app-fornecedor-pedido-compra',
  templateUrl: './fornecedor-pedido-compra.component.html',
  styleUrl: './fornecedor-pedido-compra.component.css'
})
export class FornecedorPedidoCompraComponent implements OnInit {

  pageTitle: string = '';
  showPage: boolean = false;

  dadosFornecedor: DadosFornecedor = defaultDadosFornecedor();
  dadosCabec: FornecedorPedidoCompra = defaultFornecedorPedidoCompra();
  tabelaProdutosItens: Array<FornecedorPedidoCompraItens> = [];

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private poDialogService: PoDialogService,
    private poStorageService: PoStorageService,
    private pedidoCompraService: PedidoCompraService,
  ){};

  public readonly tabelaProdutosColumns: Array<PoTableColumn> = [
    {property: 'cProduto'       , label: 'Código Produto'},
    {property: 'cDescProdServ'  , label: 'Descrição do Produto/Serviço'},
    {property: 'cNcm'           , label: 'NCM/SH'},
    {property: 'nQuantidade'    , label: 'Quantidade'},
    {property: 'cUm'            , label: 'UN'},
    {property: 'cDataEntrega'   , label: 'Data Entrega'},
    {property: 'nValorUnit'     , label: 'Vlr. Unitário'},
    {property: 'nValorTotal'    , label: 'Valor Total'},
    {property: 'nIcm'           , label: 'ICM'},
    {property: 'nIpi'           , label: 'IPI'},
    {property: 'cDescTes'       , label: 'Descrição da TES'},
  ];

  async ngOnInit() {
    localStorage.clear();
    this.poStorageService.clear();
    await this.authService.autoLogin('portal', '9bLkksY,Q6');

    this.route.params.subscribe(async (params) => {
      if ('CCHAVE' in params && 'CCODFOR' in params && 'CLOJFOR' in params) {
        this.dadosFornecedor.CCHAVE   = params.CCHAVE;
        this.dadosFornecedor.CCODFOR  = params.CCODFOR;
        this.dadosFornecedor.CLOJFOR  = params.CLOJFOR;
        this.dadosFornecedor.CIP      = (await firstValueFrom(this.authService.getIP())).ip;
        this.loadDados()
      }
    });
  };

  loadDados(): void {
    this.pedidoCompraService.getDadosPedidoCompra(this.dadosFornecedor).subscribe((ret) => {
      if(ret.cPedido){
        this.dadosCabec = ret;
        this.tabelaProdutosItens = ret.items;
        this.showPage = true;
        this.pageTitle = `Pedido de Compra - ${this.dadosCabec.cPedido}`
      } else {
        this.poDialogService.alert({
          title: 'Atenção!',
          message: 'Dados não encontrados. Caso tenha dúvidas, favor entrar em contato com a Solida.',
          ok: () => this.goToSolida()
        });
      }
    })
  };

  goToSolida(): void {
    window.location.href = 'http://www.solidabrasil.com.br'
  };

}
